import { Form } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import { withTheme } from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Table from '../../components/Table/index.js';
import _TableHeader from '../../components/Table/TableHeader.js';
import TableBody from '../../components/Table/TableBody.js';
import Paginator from '../Paginator/index.js';
import TableController from './TableController.js';
import NoDataRow from './_NoDataRow.js';
import TableBodyRows from './_TableBodyRows.js';
import TableFilterRow from './_TableFilterRow.js';
import TableHeaderRow from './_TableHeaderRow.js';
import '../../index.js';

var _excluded = ["columns", "data", "defaultSorted", "filterable", "isHoverable", "isSelectable", "hasSelectAll", "paginated", "defaultPageSize", "rowIdentifier", "sortable", "selectedRef", "theme", "tableApi", "onSelectedChange", "returnAll", "maxHeight", "fixHeaders", "columnBanding", "rowBanding", "noDataMessage"];
var _templateObject;
var TableContainer = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  @media (max-width: 576px) {\n    overflow-x: auto;\n  }\n\n  ", "\n"])), function (_ref) {
  var maxHeight = _ref.maxHeight;
  return !!maxHeight ? "\n    overflow-y:auto;\n    overflow-x: hidden;\n    max-height: ".concat(maxHeight, ";") : null;
});
function Table(_ref2) {
  var columns = _ref2.columns,
    data = _ref2.data,
    _ref2$defaultSorted = _ref2.defaultSorted,
    defaultSorted = _ref2$defaultSorted === void 0 ? [] : _ref2$defaultSorted,
    _ref2$filterable = _ref2.filterable,
    filterable = _ref2$filterable === void 0 ? false : _ref2$filterable,
    _ref2$isHoverable = _ref2.isHoverable,
    isHoverable = _ref2$isHoverable === void 0 ? true : _ref2$isHoverable,
    isSelectable = _ref2.isSelectable,
    hasSelectAll = _ref2.hasSelectAll,
    _ref2$paginated = _ref2.paginated,
    paginated = _ref2$paginated === void 0 ? false : _ref2$paginated,
    _ref2$defaultPageSize = _ref2.defaultPageSize,
    defaultPageSize = _ref2$defaultPageSize === void 0 ? 10 : _ref2$defaultPageSize,
    _ref2$rowIdentifier = _ref2.rowIdentifier,
    rowIdentifier = _ref2$rowIdentifier === void 0 ? 'id' : _ref2$rowIdentifier,
    _ref2$sortable = _ref2.sortable,
    sortable = _ref2$sortable === void 0 ? true : _ref2$sortable,
    selectedRef = _ref2.selectedRef,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    tableApi = _ref2.tableApi,
    onSelectedChange = _ref2.onSelectedChange,
    _ref2$returnAll = _ref2.returnAll,
    returnAll = _ref2$returnAll === void 0 ? false : _ref2$returnAll,
    maxHeight = _ref2.maxHeight,
    _ref2$fixHeaders = _ref2.fixHeaders,
    fixHeaders = _ref2$fixHeaders === void 0 ? false : _ref2$fixHeaders,
    _ref2$columnBanding = _ref2.columnBanding,
    columnBanding = _ref2$columnBanding === void 0 ? false : _ref2$columnBanding,
    _ref2$rowBanding = _ref2.rowBanding,
    rowBanding = _ref2$rowBanding === void 0 ? false : _ref2$rowBanding,
    noDataMessage = _ref2.noDataMessage,
    rest = _objectWithoutProperties(_ref2, _excluded);
  // @ts-ignore
  var _rest = _objectSpread2({}, rest),
    dataTestId = _rest['data-testid'];
  // Flatten columns to only columns that contain data (parent columns for sub-headers are excluded from this)
  var flatColumns = [];
  var _addColumn = function addColumn(col) {
    if (col.columns) {
      col.columns.forEach(_addColumn);
    } else {
      flatColumns.push(col);
    }
  };
  columns.forEach(_addColumn);
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TableController, {
    data: data,
    defaultSorted: defaultSorted,
    isSelectable: !!isSelectable,
    rowIdentifier: rowIdentifier,
    columns: flatColumns,
    sortable: sortable,
    filterable: filterable,
    defaultPageSize: paginated ? defaultPageSize : undefined,
    paginated: paginated,
    selectedRef: selectedRef,
    onSelectedChange: onSelectedChange,
    tableApi: tableApi,
    returnAll: returnAll
  }, function (state, _, instance) {
    // create a shallow copy so TableBodyRows
    // know its a "new" set of data
    // @ts-ignore
    var sortedData = paginated ? _toConsumableArray(state.pageRows) : _toConsumableArray(state.sortedData);
    return /*#__PURE__*/React.createElement(TableContainer, {
      maxHeight: maxHeight,
      'data-testid': 'tableContainer'
    }, /*#__PURE__*/React.createElement(_Table, _extends({
      theme: theme,
      columnBanding: columnBanding,
      rowBanding: rowBanding
    }, rest), /*#__PURE__*/React.createElement(_TableHeader, {
      theme: theme,
      fixHeaders: fixHeaders
    }, /*#__PURE__*/React.createElement(TableHeaderRow, {
      "data-testid": "".concat(dataTestId, "-heading"),
      columns: columns,
      theme: theme,
      sortColumn: instance.sortColumn,
      sortable: sortable,
      sortingRule: state.sorted && state.sorted[0]
    }), filterable ? /*#__PURE__*/React.createElement(TableFilterRow, {
      "data-testid": "".concat(dataTestId, "-filter"),
      hasSelectAll: hasSelectAll,
      columns: state.columns,
      filterColumn: instance.filterColumn,
      theme: theme,
      sortedData: state.sortedData,
      numberOfItems: data.length
    }) : null), /*#__PURE__*/React.createElement(TableBody, null, noDataMessage && data.length === 0 ? /*#__PURE__*/React.createElement(NoDataRow, {
      message: noDataMessage,
      colSpan: columns.length,
      theme: theme
    }) : /*#__PURE__*/React.createElement(TableBodyRows, {
      "data-testid": "".concat(dataTestId, "-row"),
      columns: state.columns,
      data: sortedData,
      isHoverable: isHoverable,
      theme: theme
    }))), paginated ? /*#__PURE__*/React.createElement(Paginator, {
      data: state.sortedData,
      currentPage: state.page,
      rowsPerPage: state.pageSize,
      setCurrentPage: instance.onPageChange,
      setRowsPerPage: instance.onPageSizeChange,
      managed: false
    }) : null);
  }));
}
/**
 * Doing a little "magic" here to get around passing the generic
 * type through withTheme
 */
// tslint:disable-next-line:max-classes-per-file
function ThemedTable(parentProps) {
  var TableElement = withTheme(withDefaultTheme(/*#__PURE__*/memo(function (props) {
    return /*#__PURE__*/React.createElement(Table, _extends({}, props, parentProps));
  })));
  return /*#__PURE__*/React.createElement(TableElement, null);
}

export { Table, ThemedTable };
